(function () {
  function initOliveMobileQuickbuy() {
    // Open drawer
    document.querySelectorAll('[data-omqb-open]').forEach(trigger => {
  if (trigger._omqbBound) return;
  trigger._omqbBound = true;

  trigger.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (trigger.disabled || trigger.getAttribute('data-available') === 'false') return;

    const hasVariants = trigger.getAttribute('data-has-variants') === 'true';

    if (!hasVariants) {
      // Single variant — add to cart directly
      const variantId = trigger.getAttribute('data-variant-id');
      const originalHTML = trigger.innerHTML;
      trigger.style.backgroundColor = '#4a7c59';
      trigger.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg>';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(r => r.json())
      .then(() => {
        // Open cart drawer
        document.dispatchEvent(new CustomEvent('cart:open'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();

        setTimeout(() => {
          trigger.innerHTML = originalHTML;
          trigger.style.backgroundColor = '';
        }, 1500);
      })
      .catch(err => {
        console.error('Quick add error:', err);
        trigger.innerHTML = originalHTML;
        trigger.style.backgroundColor = '';
      });

    } else {
      // Multi-variant — open drawer
      const key = trigger.getAttribute('data-omqb-open');
      openDrawer(key);
    }
  });
});


    // Close via overlay
    document.querySelectorAll('[data-omqb-overlay]').forEach(overlay => {
      if (overlay._omqbBound) return;
      overlay._omqbBound = true;
      overlay.addEventListener('click', () => {
        const key = overlay.getAttribute('data-omqb-overlay');
        closeDrawer(key);
      });
    });

    // Close via X button
    document.querySelectorAll('[data-omqb-close]').forEach(btn => {
      if (btn._omqbBound) return;
      btn._omqbBound = true;
      btn.addEventListener('click', () => {
        const key = btn.getAttribute('data-omqb-close');
        closeDrawer(key);
      });
    });

    // Variant pill selection
    document.querySelectorAll('[data-omqb-pills]').forEach(pillGroup => {
      if (pillGroup._omqbBound) return;
      pillGroup._omqbBound = true;

      pillGroup.querySelectorAll('button').forEach(pill => {
        pill.addEventListener('click', () => {
          if (pill.disabled) return;
          pillGroup.querySelectorAll('button').forEach(p => p.classList.remove('selected'));
          pill.classList.add('selected');

          const key = pillGroup.getAttribute('data-omqb-pills');
          const variantId = pill.getAttribute('data-variant-id');
          const price = pill.getAttribute('data-price');

          // Update ATC button variant
          const atcBtn = document.querySelector(`[data-omqb-atc="${key}"]`);
          if (atcBtn) atcBtn.setAttribute('data-variant-id', variantId);

          // Update displayed price
          const priceEl = document.querySelector(`[data-omqb-price="${key}"]`);
            if (priceEl) priceEl.innerHTML = pill.getAttribute('data-price');

        // Swap image
            const imgEl = document.getElementById(`omqb-img-${key}`);
             if (imgEl && imageUrl) imgEl.src = imageUrl;
        });
      });
    });

    // Quantity stepper
    document.querySelectorAll('[data-omqb-qty-dec]').forEach(btn => {
      if (btn._omqbBound) return;
      btn._omqbBound = true;
      btn.addEventListener('click', () => {
        const input = btn.closest('[class*="omqb-qty-"]').querySelector('[data-omqb-qty-input]');
        if (input && parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
      });
    });

    document.querySelectorAll('[data-omqb-qty-inc]').forEach(btn => {
      if (btn._omqbBound) return;
      btn._omqbBound = true;
      btn.addEventListener('click', () => {
        const input = btn.closest('[class*="omqb-qty-"]').querySelector('[data-omqb-qty-input]');
        if (input && parseInt(input.value) < 99) input.value = parseInt(input.value) + 1;
      });
    });

    // Add to cart
    document.querySelectorAll('[data-omqb-atc]').forEach(btn => {
      if (btn._omqbBound) return;
      btn._omqbBound = true;

      btn.addEventListener('click', () => {
        const variantId = btn.getAttribute('data-variant-id');
        const drawer = btn.closest('[data-omqb-drawer]');
        const qtyInput = drawer && drawer.querySelector('[data-omqb-qty-input]');
        const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

        const originalText = btn.textContent;
        btn.textContent = 'Adding…';
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity })
        })
        .then(r => r.json())
        .then(() => {
          btn.textContent = 'Added ✓';

          // Trigger theme cart drawer
          document.dispatchEvent(new CustomEvent('cart:open'));
          document.dispatchEvent(new CustomEvent('cart:refresh'));

          // Also try Shopify's native cart drawer event (Dawn / most themes)
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }

          // Close quickbuy drawer after short delay
          setTimeout(() => {
            const key = btn.getAttribute('data-omqb-atc');
            closeDrawer(key);
            btn.textContent = originalText;
            btn.disabled = false;
          }, 800);
        })
        .catch(err => {
          console.error('Quick buy error:', err);
          btn.textContent = 'Error — try again';
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
        });
      });
    });

    // Image gallery swipe + dots
    document.querySelectorAll('[data-omqb-track]').forEach(track => {
      if (track._omqbBound) return;
      track._omqbBound = true;

      const key = track.getAttribute('data-omqb-track');
      const dots = document.querySelector(`[data-omqb-dots="${key}"]`);
      let currentIndex = 0;
      let startX = 0;

      function goTo(index) {
        const slides = track.querySelectorAll('[class*="omqb-gallery-slide-"]');
        if (index < 0 || index >= slides.length) return;
        currentIndex = index;
        track.style.transform = `translateX(-${currentIndex * 100}%)`;
        if (dots) {
          dots.querySelectorAll('button').forEach((dot, i) => {
            dot.classList.toggle('active', i === currentIndex);
          });
        }
      }

      // Dot clicks
      if (dots) {
        dots.querySelectorAll('button').forEach(dot => {
          dot.addEventListener('click', () => goTo(parseInt(dot.getAttribute('data-index'))));
        });
      }

      // Touch swipe
      track.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', e => {
        const diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) goTo(diff > 0 ? currentIndex + 1 : currentIndex - 1);
      }, { passive: true });
    });
  }

  function openDrawer(key) {
    const overlay = document.querySelector(`[data-omqb-overlay="${key}"]`);
    const drawer = document.querySelector(`[data-omqb-drawer="${key}"]`);
    if (overlay) overlay.classList.add('open');
    if (drawer) drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer(key) {
    const overlay = document.querySelector(`[data-omqb-overlay="${key}"]`);
    const drawer = document.querySelector(`[data-omqb-drawer="${key}"]`);
    if (overlay) overlay.classList.remove('open');
    if (drawer) drawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOliveMobileQuickbuy);
  } else {
    initOliveMobileQuickbuy();
  }
})();
